import { useURLParameters } from 'hooks';
import {
  CustomerLocationsModalViewType,
  CustomerLocationsComponentMap,
} from './CustomerLocationsModal.constants';
import { customerLocationsModalRoutingService } from './CustomerLocationsModalRouting.constants';
import { createContext, FC, useCallback, useContext, useEffect } from 'react';

export interface ICustomerLocationsModalUI {
  isOpen: boolean;
  onClose: () => void;
  customerLocationsActiveModalView: CustomerLocationsModalViewType;
  customerId: string;
}

export const CustomerLocationsModalUIContext = createContext<ICustomerLocationsModalUI>(
  {} as ICustomerLocationsModalUI,
);

export const CustomerLocationsModalUIProvider: FC = ({ children }) => {
  const [{ customerId, customerLocationsActiveModalView }, { removeParam }] =
    useURLParameters<{ customerLocationsActiveModalView: CustomerLocationsModalViewType }>();

  const handleClose = useCallback(() => {
    customerLocationsModalRoutingService.close();
  }, []);

  useEffect(() => {
    if (!Object.keys(CustomerLocationsComponentMap).includes(customerLocationsActiveModalView)) {
      removeParam(['customerLocationsActiveModalView']);
    }
  }, [customerLocationsActiveModalView, removeParam]);

  return (
    <CustomerLocationsModalUIContext.Provider
      value={{
        isOpen: !!customerLocationsActiveModalView,
        onClose: handleClose,
        customerLocationsActiveModalView:
          customerLocationsActiveModalView as CustomerLocationsModalViewType,
        customerId,
      }}
    >
      {children}
    </CustomerLocationsModalUIContext.Provider>
  );
};

export const useCustomerLocationsModalUIContext = () =>
  useContext<ICustomerLocationsModalUI>(CustomerLocationsModalUIContext);
